import React from 'react';
import QRCode from "react-qr-code";
import {QrTypeIcon} from './QrTypeIcon';
import PropTypes from 'prop-types';
import 'css/qr-print.css';
export const QrPrintArea = ({params,uuid}) =>{
		return(
			<div className="print-area d-flex flex-row justify-content-center" style={{top: params.top, left: params.left}}>
			<div className="text-center d-block">
				<div id="print-html">
					<QRCode id="QRCode" size= {params.size} value={uuid} level="M"/>
					<b style={{color:'black',display:'block',fontSize:params.fontSize,fontWeight: 'bolder',verticalAlign: 'middle'}}>
						<QrTypeIcon type={params.type}/>{params.id}
					</b>
				</div>
			</div>
			{params.type === 'locker' &&
				<div className="d-flex text-left pt-3 align-self-start" style={{paddingLeft:params.rightFontPaddingLeft}}>
					<h1 style={{fontSize:params.rightFontSize}}>Locker<br/>Ref. Code</h1>
				</div>

			}
			</div>
		)
}
QrPrintArea.propTypes = {
	params: PropTypes.object,
	uuid: PropTypes.string,
};
